import React, { useState, useEffect } from 'react'
import { Cursor } from './styles'

interface Props {
    text: string
    typeFinishCallback: () => void
    speed?: number
}

const TypewriterEffect: React.FC<Props> = ({ text, typeFinishCallback, speed = 25 }) => {
    const [displayedText, setDisplayedText] = useState('')
    useEffect(() => {
        let index = 0
        const startTime = Date.now()

        const interval = setInterval(() => {
            const elapsed = Date.now() - startTime

            if (elapsed > 2000) {
                // show remaining text after 2 seconds
                setDisplayedText(text)
                clearInterval(interval)
                if (typeFinishCallback) typeFinishCallback()
                return
            }

            setDisplayedText(prev => prev + text.charAt(index))
            index++

            if (index >= text.length) {
                clearInterval(interval)
                if (typeFinishCallback) typeFinishCallback()
            }
        }, speed)

        return () => {
            clearInterval(interval)
        }
    }, [text, speed])

    return (
        <div className="typewriter-effect">
            {displayedText}
            {<Cursor>|</Cursor>}
        </div>
    )
}

export default TypewriterEffect
